import React from 'react';
import {
  TextField,
  Button,
  IconButton,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography
} from "@mui/material";
import { ExpandMore, Add, Delete } from "@mui/icons-material";

export const OptionsSettings = ({ options, setProp }) => {
  const addOption = () => {
    const newOptions = [...(options || []), { value: '', label: '' }];
    setProp(props => props.options = newOptions);
  };

  const removeOption = (index) => {
    const newOptions = options.filter((_, i) => i !== index);
    setProp(props => props.options = newOptions);
  };

  const updateOption = (index, field, value) => {
    const newOptions = [...options];
    newOptions[index] = { ...newOptions[index], [field]: value };
    setProp(props => props.options = newOptions);
  };

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography variant="subtitle2">Options</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div>
          {(options || []).map((option, index) => (
            <Box key={index} sx={{ display: 'flex', gap: 1, mb: 2, alignItems: 'center' }}>
              <TextField
                label="Value"
                value={option.value}
                onChange={(e) => updateOption(index, 'value', e.target.value)}
                size="small"
                sx={{ flex: 1 }}
              />
              <TextField
                label="Label"
                value={option.label}
                onChange={(e) => updateOption(index, 'label', e.target.value)}
                size="small"
                sx={{ flex: 1 }}
              />
              <IconButton
                onClick={() => removeOption(index)}
                color="error"
                size="small"
              >
                <Delete />
              </IconButton>
            </Box>
          ))}
          <Button
            startIcon={<Add />}
            onClick={addOption}
            variant="outlined"
            size="small"
            fullWidth
          >
            Add Option
          </Button>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};